import INApi from './_inApi.js';

class INTransferAPI extends INApi {
  constructor() {
    super();
  }
  controllerName = 'INTransfers';
}
export default new INTransferAPI();
